import script from "./AppLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AppLayout.vue?vue&type=style&index=0&id=c312128e&lang=css"
import "./AppLayout.vue?vue&type=style&index=1&id=c312128e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c312128e"]])

export default __exports__